import React from 'react';
import { Form } from "react-bootstrap";
import axios from 'axios';

const reqDepartment = (faculty_id) => {
    let data = { faculty_id: faculty_id };
    axios.post(`${process.env.REACT_APP_ENDPOINT}/masterregis/department`, data, {
        headers: {
            'Content-Type': 'application/json',
            'authtoken': `${process.env.REACT_APP_AUTH_KEY}`
        }
    })
    .then(resp => { 
        const { data, return_code, return_message } = resp.data;
        
        var html = '<select class="form-select" id="department" name="department" class="required">';

        if (return_code === '0000') {
            data.map(function(item) {
                html += `<option key=${item.department_id} value=${item.department_id}>${item.department_name_th}</option>`;
            });
        } else {
            console.log(return_message);
        }

        html += "</select>";
        document.getElementById('div_department').innerHTML = html;
    });
}

export default class FacultyList extends React.Component {
    constructor(props) {
        super(props);
        this.state = { datas: null }

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        var data = { };
        axios.post(`${process.env.REACT_APP_ENDPOINT}/masterregis/faculty`, data, {
            headers: {
                'Content-Type': 'application/json',
                'authtoken': `${process.env.REACT_APP_AUTH_KEY}`
            }
        })
        .then(resp => { 
            const { data, return_code, return_message } = resp.data
            if (return_code === '0000') {
                this.setState({ datas: data});
                var faculty_id = data[0].faculty_id;
                reqDepartment(faculty_id);
            } else {
                console.log(return_message);
            }
        });
    }

    handleChange(e) {
        var faculty_id = e.target.value;
        reqDepartment(faculty_id);
    }

    render() {
        const { datas } = this.state;

        if (datas != null) {
            let items = datas.map((data) => 
                <option key={data.faculty_id} value={data.faculty_id}>{data.faculty_name_th}</option>
            );
            return (
                <Form.Select id={this.props.id} className={this.props.className} onChange={this.handleChange}>
                    {items}
                </Form.Select>
            )
        } else {
            return (
                <div className='loading'>Loading</div>
            )
        }
    }

}